const state = {
  layout: 'layout-basic',
};

const mutations = {
  setLayout(state, payload) {
    state.layout = payload;
  },
};

const getters = {
  layout(state) {
    return state.layout;
  },
};

export const layout = {
  namespaced: true,
  state,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/layout.module.js